import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Leaf } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-foreground text-background mt-24">
      <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo size={32} dark />
          <p className="mt-4 text-sm text-background/70 max-w-sm font-display">
            Spazio vuoto, valore pieno. Ottimizza ogni chilometro.
          </p>
          <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 rounded-sm px-2.5 py-1">
            <Leaf size={13} /> Meno viaggi a vuoto = meno CO₂
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="label-eyebrow text-accent mb-4">Piattaforma</h4>
          <ul className="space-y-2 text-sm text-background/80">
            <li><Link to="/cerca" className="hover:text-accent transition-colors">Cerca tratta</Link></li>
            <li><Link to="/news" className="hover:text-accent transition-colors">News di settore</Link></li>
            <li><Link to="/accedi?tab=register" className="hover:text-accent transition-colors">Diventa trasportatore</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="label-eyebrow text-accent mb-4">Assicurazione</h4>
          <p className="text-sm text-background/70">
            Ogni spedizione può essere assicurata tramite una compagnia esterna al costo del <span className="text-accent font-semibold">3% del valore assicurato</span>.
          </p>
        </div>
      </div>
      <div className="border-t border-background/10 py-5 text-center text-xs text-background/50 font-mono-plex">
        © {new Date().getFullYear()} Truck Sharing — Ottimizzazione dei viaggi a vuoto
      </div>
    </footer>
  );
}
